<template>
    <div @click="addToCart" class="card card__ticket_type" :class="{
        disabled: isDisabled,
        'on-error': onError
        }">
        <div class="top">
            <h3 class="card--title">{{ ticketType.name }}</h3>
            <div v-if="isDisabledByMinimum" class="quota-minimum-hint">
                {{ t('quotaPerOrder.minimum_exceeds', { min: minimumSelectable, remaining: cartStore.remainingQuota }) }}
            </div>
        </div>
        <div class="bottom">
            <div class="price">
                {{ formattedPrice }}
            </div>
            <div v-if="ticketType.stocks.quota && !eventStore.isRoomPlacement" class="stock">
                <IconSvg class="icon" width="20" :name="'ticket'" />
                <span>{{ ticketType?.currentStock }}</span>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useCartStore } from '@/stores/CartStore';
import { TicketType } from "@/interfaces/TicketType";
import { AppPrice } from '@/tools/Price';
import IconSvg from '@/components/atoms/ASvg.vue';
import { TicketTypeCategory } from "@/interfaces/TicketTypeCategory";
import { useEventStore } from "@/stores/EventStore";
    interface Props {
        ticketType: TicketType
        category: TicketTypeCategory
    }

    const onError = ref(false)
    const { t } = useI18n();
    const cartStore = useCartStore()
    const eventStore = useEventStore()
    const props = withDefaults(defineProps<Props>(), {})

    const formattedPrice = computed(() => {
        const price = Number(props.ticketType.price)
        return new AppPrice(price).divide100().formatted
    })

    const minimumSelectable = computed(() => {
        let amount = 1
        if (props.ticketType.tickets?.minimumSelectable) {
            amount = props.ticketType.tickets?.minimumSelectable
        }
        return amount
    })

    // Vrai si le tarif est désactivé à cause du quota global atteint.
    const isDisabledByQuota = computed(() => {
        return cartStore.isQuotaReached
    })

    // Vrai si ce tarif nécessite un minimum d'achat supérieur au quota restant.
    // S'applique uniquement si ce tarif n'est pas encore dans le panier.
    const isDisabledByMinimum = computed(() => {
        if (cartStore.quotaPerOrderEffective === null) return false
        const min = minimumSelectable.value
        if (min <= 1) return false
        const currentQtyForThisType = cartStore.getItemPerTicketType(props.ticketType)?.quantity ?? 0
        if (currentQtyForThisType > 0) return false
        return min > cartStore.remainingQuota
    })

    const isDisabled = computed(() => {
        const globalStock = (eventStore.currentEvent._app.currentStock !== null) ? eventStore.currentEvent._app.currentStock : Number.MAX_SAFE_INTEGER
        if (globalStock <= 0 || props.ticketType.isDisabled || (props.category && props.category.isDisabled)) {
            return true
        }
        // Désactivé si quota global atteint ou si minimum non satisfiable
        return isDisabledByQuota.value || isDisabledByMinimum.value
    })

    const addToCart = () => {
        if (!isDisabled.value) {
            for (let index = 0; index < minimumSelectable.value; index++) {
                cartStore.addTicket(props.ticketType)
            }
        }
        else {
            onError.value = true
            setTimeout(() => {
                onError.value = false
            }, 1000);
        }
    }

</script>